export const SOCIAL_LINE_URL="https://lin.ee/j4UUUoh"
export const SOCIAL_TIKTOK_URL="https://www.tiktok.com/@keptscene?_r=1&_t=ZS-92W4Qgy6As8"
export const SOCIAL_INSTRAGRAM_URL="https://www.instagram.com/keptscene?igsh=c3M1YmsyMTVweG1x&utm_source=qr"